
/**
 * Index-classic-saas component
 */
import { CheckCircleIcon, XCircleIcon, ClockIcon } from 'vue-feather-icons'

import WithdrawForm from "@/components/withdraw-form";
import omiseService from "../../../services/omiseService";
import withdrawService from "../../../services/withdrawService";
import accountMenu from "@/views/account/menu.vue";
import bankService from "../../../services/bankAccount";
export default {
    components: {
        CheckCircleIcon,
        XCircleIcon,
        ClockIcon,

        accountMenu,
        WithdrawForm
    },
    data: () => ({
        withdrawConfig: {},
        minWithdraw: 1000,
        modalWithdrawShow: false,
        withdrawHistory: [],
        balance: 0,
        headers: [
            {
                text: "Date",
                align: "center",
                sortable: false,
                value: "created_at",
            },
            {
                text: "Amount (THB)",
                align: "center",
                sortable: false,
                value: "amount",
            },
            {
                text: "Fee (THB)",
                align: "center",
                sortable: false,
                value: "fee",
            },
            {
                text: "Account",
                align: "left",
                sortable: false,
                value: "detail",
            },
            {
                text: "Status",
                align: "center",
                sortable: false,
                value: "status",
            },
            {
                text: "Comment",
                align: "left",
                sortable: false,
                value: "note",
            },
            {
                text: "Slip",
                align: "left",
                sortable: false,
                value: "slip",
            },
        ],
        currentAccount: null,
        withdrawable: false,
        overlay: false,
        progressModal: false,
    }),
    mounted() {
        // this.getBillingHistory();
        this.getCurrentAccount();
    },
    watch: {
        modalWithdrawShow(val) {
            if (val === true) {
                setTimeout(() => {
                    this.$refs.withdrawForm.init()
                });
            }
        }
    },
    methods: {
        getBillingHistory() {
            withdrawService.getWithdrawableAmount().then(resp => {

                this.balance = resp.data.amount
                this.withdrawConfig = resp.data

                return withdrawService.listWithdrawHistory()
            }).then((resp) => {
                if (resp.data.status == true && resp.data.result != null) {
                    this.withdrawHistory = resp.data.result;
                    delete resp.data.result;
                } else {
                    throw "Can not get customer's cards";
                }
            }).catch((err) => {
                this.withdrawHistory = [];
            }).finally(() => {
                this.overlay = false
            });

        },
        getCurrentAccount() {
            this.overlay = true
            bankService
                .getBankAccount()
                .then((resp) => {
                    if (resp.data.length > 0) {
                        this.hasSetup = true;
                        const currentBank = resp.data[0];
                        if (currentBank.verified === true && currentBank.active === true) {
                            this.withdrawable = true
                        } else {
                            this.withdrawable = false
                        }

                        this.currentAccount = currentBank;
                    } else {
                        // not setup yet
                        this.currentAccount = null;
                        this.withdrawConfig = {}
                        this.withdrawable = false
                    }
                })
                .catch((err) => {
                    this.overlay = false
                    // do nothing
                }).finally(() => {
                    this.getBillingHistory()
                });
        },
        showDialogWithdraw() {
            if (this.currentAccount == null) {
                // alert setup bank account first
                // then routing to bank account page
                this.$router.push({
                    name: "BankAccount"
                })
            } else {
                if (this.balance < this.minWithdraw) {
                    this.$bvModal.msgBoxOk(
                        `You balance is insufficient to withdraw (minimun=${this.minWithdraw})`,
                        {
                            title: "Insufficient Balance",
                            centered: true,
                        }
                    )
                } else {
                    this.modalWithdrawShow = true
                }

            }

        },
        onTransferCreated() {
            this.modalWithdrawShow = false
            this.getBillingHistory()
        },
        handleWithdrawFormOk(bvModalEvt) {
            bvModalEvt.preventDefault();

            let withdraw = this.$refs.withdrawForm.getWithdrawInfo();
            if (withdraw == null) {
                return; // form valid
            }

            if (withdraw.amount <= 0) {
                this.modalWithdrawShow = false
                this.$bvModal.msgBoxOk('Please specific amount > 0', {
                    title: "Withdraw Request Error",
                    okVariant: "danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                })
                return
            }

            // this.createWithdrawRequest(withdraw);
            this.progressModal = true
            withdrawService.createTransfer(withdraw)
                .then((resp) => {
                    if (resp.data == true) {
                        this.$refs.withdrawForm.clear();
                        this.$bvModal.msgBoxOk('Withdraw is created successful, please wait verify process. If transfer has been process we will notify you via e-mail.').then(() => {
                            this.getBillingHistory()
                        })
                    } else {
                        // do nothing
                    }
                })
                .catch((err) => {
                    this.$bvModal.msgBoxOk(err.response.data.message, {
                        title: "Withdraw Request Error",
                        size: "sm",
                        okVariant: "danger",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                    });
                })
                .finally(() => {
                    this.modalWithdrawShow = false;
                    this.progressModal = false
                });
        },
        createWithdrawRequest(withdraw) {
            let accountNoWithoutFormat = withdraw.accountNo.replaceAll(" - ", "");
            let data = {
                type: 'bank', // 'promptpay
                amount: withdraw.amount,
                detail: {
                    account: withdraw.accountName,
                    accountNo: accountNoWithoutFormat,
                    bank: withdraw.bankName,
                }
            }

            // type: 'promptpay',
            // detail: {
            //     type: 'tel', // 'idCard'   
            //     promptpayNo: withdraw.promptpayNo,
            // }

            withdrawService
                .saveWithdraw(data)
                .then((resp) => {
                    if (resp.data.status == true && resp.data.result != null) {
                        this.modalWithdrawShow = false;
                        this.getBillingHistory();
                    } else {
                        throw "Can not save withdraw request";
                    }
                })
                .catch((err) => {
                    this.modalWithdrawShow = false;
                    this.$bvModal.msgBoxOk(err.response.message, {
                        title: "Withdraw Request Error",
                        size: "sm",
                        okVariant: "danger",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                    });
                    console.log(err);
                });
        },
    },
};
